// frontend/src/pages/Dashboard/StockDashboardCards.tsx
import React, { useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import { IoDocumentTextOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../../../../store/store";
import { fetchStockListAsync } from "../../../../../store/Slice/stockSlice";
import { setStatusFilter } from "../../../../../store/Slice/filterSlice";
import { ClipLoader } from "react-spinners";

const StockDashboardCards: React.FC = () => {
  const dispatch = useDispatch();
  const { total = 0, status, error } = useSelector((s: RootState) => s.stock);
  const statusFilter = useSelector((s: RootState) => s.filter.statusFilter);

  const loading = status === "loading";

  useEffect(() => {
    dispatch(fetchStockListAsync() as any);
  }, [dispatch]);

  const counts = useMemo(() => {
    return { total }; // ✅ total from backend
  }, [total]);

  if (error) {
    const message = typeof error === "string" ? error : (error && (error as any).message) ? (error as any).message : JSON.stringify(error);
    return <div className="text-red-600 p-4">Error: {message}</div>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-6 mb-6 text-sm">
      {/* ✅ TOTAL STOCK */}
      <motion.div
        whileHover={{ y: -5 }}
        onClick={() => dispatch(setStatusFilter("all"))}
        className={`${statusFilter === "all" ? "bg-[var(--theme-color)] text-white" : "bg-white dark:bg-zinc-950"} 
        p-4 rounded-lg shadow flex justify-between cursor-pointer font-semibold`}
      >
        <div className="flex flex-col items-start gap-3">
          <p className={`${statusFilter === "all" ? "text-white" : "text-[var(--theme-color)]"}`}>
            Total Stock
          </p>
          <p className="text-3xl font-bold">
            {loading ? <ClipLoader color="#40a7f1" /> : counts.total}
          </p>
        </div>

        <div className="w-16 flex justify-center">
          <IoDocumentTextOutline
            className="text-[var(--theme-color)] text-5xl w-fit bg-blue-100 dark:bg-zinc-700 rounded-lg p-2"
          />
        </div>
      </motion.div>

      {/* Other cards (Completed, Pending, etc.) can be added here */}
    </div>
  );
};

export default StockDashboardCards;
